module.exports = __webpack_public_path__ + "img/cuff_length.cb132bf4.png";